import { Box, Card, Grid, Text } from '@mantine/core';
import { IconProps, IconSettings, IconSpeakerphone, IconUsers } from '@tabler/icons-react';
import React, { ReactNode } from 'react';
import { MyLink, RouteInfo, SomeRouteInfo } from '../../router/createdRouter';
import { For } from '../../../../../react-commons/components/control-flow/For';

const iconProps: IconProps = {
    width: 32,
    height: 32,
    style: { color: '#488404' },
};

const adminLinks: Array<{ label: string; description: string; icon: ReactNode; routeInfo: SomeRouteInfo }> = [
    {
        label: 'System Right Management',
        description: 'Setting the rights and groups for every user',
        icon: <IconUsers {...iconProps} />,
        routeInfo: { route: '/admin-panel/system-right-management' },
    },
    {
        label: 'System Settings',
        description: 'General settings',
        icon: <IconSettings {...iconProps} />,
        routeInfo: { route: '/admin-panel/system-settings' },
    },
    {
        label: 'System Announcements',
        description: 'Additional changes, news about new features, versions',
        icon: <IconSpeakerphone {...iconProps} />,
        routeInfo: { route: '/admin-panel/system-announcements' },
    },
];

export const AdminPanel = () => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                width: '70%',
                height: 'calc(100% - 60px)',
                margin: 'auto',
                textAlign: 'justify',
                flexDirection: 'column',
            }}
        >
            <Grid
                style={{
                    overflow: 'hidden',
                    alignItems: 'center',
                }}
            >
                <For each={adminLinks} keyFn={({ label }) => label}>
                    {({ routeInfo, icon, label, description }) => (
                        <Grid.Col span={6}>
                            <MyLink {...(routeInfo as RouteInfo<(typeof routeInfo)['route']>)}>
                                <Card
                                    withBorder
                                    style={{
                                        padding: '7px',
                                        margin: '5px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <Box
                                        style={{
                                            paddingLeft: '4px',
                                            paddingRight: '4px',
                                            marginTop: 'auto',
                                            marginBottom: 'auto',
                                            display: 'flex',
                                        }}
                                    >
                                        {icon}
                                    </Box>
                                    <Box style={{ paddingLeft: '4px', paddingRight: '4px' }}>
                                        <Text size={'lg'} fw={500}>
                                            {label}
                                        </Text>
                                        <div style={{ marginTop: 'auto' }}>
                                            <Text size={'md'}>{description}</Text>
                                        </div>
                                    </Box>
                                </Card>
                            </MyLink>
                        </Grid.Col>
                    )}
                </For>
            </Grid>
        </div>
    );
};
